import type { QuoteSchema } from '@/services/quotes-schemas';

type StepWithCode = Pick<QuoteSchema['steps'][number], 'code'>;

/**
 * Returns a step `code` present in `steps`, or the first step's code when
 * `stepCodeFromUrl` is missing or not in the schema.
 */
export function resolveActiveStepCode(
  steps: StepWithCode[],
  stepCodeFromUrl: string
): string {
  if (!steps.length) return '';
  const validCodes = new Set(
    steps.map(s => s.code).filter((c): c is string => Boolean(c && c.trim()))
  );
  if (stepCodeFromUrl.trim() && validCodes.has(stepCodeFromUrl.trim())) {
    return stepCodeFromUrl.trim();
  }
  return steps[0]?.code?.trim() ?? '';
}
